<main class="main">
  <section class="wrap-title"
    style="background: url('https://siteunion.s3.sa-east-1.amazonaws.com/wp-content/uploads/2021/04/Vistoria_1920x324-1.png'); background-size: cover;">
    <div class="layout">
      <h1 class="title-page">Vistoria Veicular</h1>
    </div>
  </section>

  <section class="wrap-content">
    <div class="layout">
      <div class="content">
        <div class="left">
          <div class="ckeditor">
            <p>Mais confiança e segurança para as suas negociações. Para cada mercado veicular, a Union oferece uma
              vistoria personalizada para atender às necessidades específicas do seu negócio.</p>
            <p>Um software diferenciado e focado em oferecer as soluções mais tecnológicas, práticas e completas.</p>
          </div>
        </div>
      </div>

    </div>
  </section>


  <section class="wrap-vistorias">
    <div class="layout">
      <h2 class="subtitle">Vistorias</h2>
      <div class="list-topics list-vistorias">

        <div class="topic vistoria">
          <div class="text">
            <h3>Auto Vistoria</h3>
            <p class="tag">Seguradoras | Financeiras | Corretoras Indústrias | Consórcios | Operadoras de Saúde</p>
            <p class="description">Um processo de vistoria feito de forma prática e rápida é a solução ideal para sua
              empresa assumir o total controle na autoinspeção de veículos. Processos totalmente automatizados e 100%
              online, garantindo o melhor custo-benefício para a sua empresa.</p>
          </div>
        </div>

        <div class="topic vistoria">
          <div class="text">
            <h3>Vistoria de Avaliação</h3>
            <p class="tag">Mercado Financeiro (Precificação)</p>
            <p class="description">Seu negócio não pode falhar no processo de revenda, entrega amigável, compra e venda.
              Acesse todas as informações necessárias para garantir a precificação de forma mais assertiva e rentável do
              valor real de mercado, baseado na avaliação do veículo.</p>
          </div>
        </div>

        <div class="topic vistoria">
          <div class="text">
            <h3>Vistoria de Constatação</h3>
            <p class="tag">Mercado Financeiro e Consórcios</p>
            <p class="description">Vai constatar a atual situação do veículo a fim de fazer os apontamentos relevantes e
              auxiliar na decisão de desmobilização da frota. Oferece todas as informações necessárias para o
              financiamento, contemplação, refinanciamento e substituição de garantia.</p>
          </div>
        </div>

        <div class="topic vistoria">
          <div class="text">
            <h3>Vistoria de Devolução de Frota</h3>
            <p class="tag">Locadoras e Montadoras</p>
            <p class="description">Segurança e confiabilidade na avaliação do estado de conservação do bem por avarias
              ou ausência de acessórios/equipamentos do veículo.</p>
          </div>
        </div>

        <div class="topic vistoria">
          <div class="text">
            <h3>Vistoria Cautelar</h3>
            <p class="tag">Mercado de compra e venda (usados)</p>
            <p class="description">Os dados mais assertivos para o seu negócio de forma personalizável. Selecione as
              informações de acordo com as necessidades específicas da sua empresa para tomar a melhor decisão.</p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <app-contact-box></app-contact-box>
</main>